/* eslint-disable no-sequences */
import * as tf from '@tensorflow/tfjs'

export const predict = async (activities, tenPersonalItemInventory, wordDefinitions) => {
    const activitiesPercentage = (activities.filter(activity => activity !== 0).length / activities.length) * 100
    const tenPersonalItemInventoryPercentage = (tenPersonalItemInventory.filter(personalItemInventory => personalItemInventory !== 0).length / tenPersonalItemInventory.length) * 100
    const wordDefinitionsPercentage = (wordDefinitions.filter(wordDefinition => wordDefinition !== -1).length / wordDefinitions.length) * 100
    const percentages = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
    const selectedModel = percentage => {
        let diff = 1000
        let selectedIndex = 0
        for (let i = 0; i < percentages.length; i++) {
            const element = percentages[i];
            if (Math.abs(element - percentage) < diff) {
                diff = Math.abs(element - percentage)
                selectedIndex = i
            }
        }
        diff = 1000
        const firstClosest = percentages[selectedIndex]
        let percentagesCopy = [...percentages]
        percentagesCopy.splice(selectedIndex, 1)
        for (let i = 0; i < percentagesCopy.length; i++) {
            const element = percentagesCopy[i];
            if (Math.abs(element - percentage) < diff) {
                diff = Math.abs(element - percentage)
                selectedIndex = i
            }
        }
        const secondClosest = percentagesCopy[selectedIndex]
        return [firstClosest, secondClosest]
    }
    let [firstModelForActivities, secondModelForActivities] = selectedModel(activitiesPercentage)
    let [firstModelForTenPersonalItemInventory, secondModelForTenPersonalItemInventory] = selectedModel(tenPersonalItemInventoryPercentage)
    let [firstModelForWordDefinitions, secondModelForWordDefinitions] = selectedModel(wordDefinitionsPercentage)

    if (activitiesPercentage !== 100) {
        firstModelForTenPersonalItemInventory = 0
        secondModelForTenPersonalItemInventory = 0

        firstModelForWordDefinitions = 0
        secondModelForWordDefinitions = 0
    } else if (activitiesPercentage === 100 && tenPersonalItemInventoryPercentage !== 100) {
        firstModelForActivities = 100
        secondModelForActivities = 100

        firstModelForWordDefinitions = 0
        secondModelForWordDefinitions = 0
    } else {
        firstModelForActivities = 100
        secondModelForActivities = 100

        firstModelForTenPersonalItemInventory = 100
        secondModelForTenPersonalItemInventory = 100
    }

    activities = activities.map(element => element / 5.0)
    activities = tf.tensor(activities)
    activities = activities.expandDims(0)
    tenPersonalItemInventory = tenPersonalItemInventory.map(element => element / 7.0)
    tenPersonalItemInventory = tf.tensor(tenPersonalItemInventory)
    tenPersonalItemInventory = tenPersonalItemInventory.expandDims(0)
    wordDefinitions = tf.tensor(wordDefinitions)
    wordDefinitions = wordDefinitions.expandDims(0)

    const activitiesModels = [...new Set([firstModelForActivities, secondModelForActivities])]
    const tenPersonalItemInventoryModels = [...new Set([firstModelForTenPersonalItemInventory, secondModelForTenPersonalItemInventory])]
    const wordDefinitionsModels = [...new Set([firstModelForWordDefinitions, secondModelForWordDefinitions])]

    let combinations = []

    for (let index = 0; index < activitiesModels.length; index++) {
        const activitiesModel = activitiesModels[index];
        for (let index = 0; index < tenPersonalItemInventoryModels.length; index++) {
            const tenPersonalItemInventoryModel = tenPersonalItemInventoryModels[index];
            for (let index = 0; index < wordDefinitionsModels.length; index++) {
                const wordDefinitionsModel = wordDefinitionsModels[index];
                combinations.push([activitiesModel, tenPersonalItemInventoryModel, wordDefinitionsModel])
            }
        }
    }


    let models = []

    for (let index = 0; index < combinations.length; index++) {
        const [modelForActivities, modelForTenPersonalItemInventory, modelForWordDefinitions] = combinations[index];
        try {
            models.push(await tf.loadLayersModel(`indexeddb://${modelForActivities}_${modelForTenPersonalItemInventory}_${modelForWordDefinitions}_percent_model`))
        } catch (error) {
            models.push(await tf.loadLayersModel(`https://personality.rezanmz.com/models/${modelForActivities}_${modelForTenPersonalItemInventory}_${modelForWordDefinitions}_percent/model.json`))
            models[models.length - 1].save(`indexeddb://${modelForActivities}_${modelForTenPersonalItemInventory}_${modelForWordDefinitions}_percent_model`)
        }
    }

    let predictions = []
    for (let index = 0; index < models.length; index++) {
        const model = models[index]
        predictions.push(model.predict([activities, tenPersonalItemInventory, wordDefinitions]))
    }

    let result = []
    for (let index = 0; index < predictions.length; index++) {
        const prediction = predictions[index]
        if (result.length === 0)
            result = prediction
        else {
            result[0] = tf.add(result[0], prediction[0])
            result[1] = tf.add(result[1], prediction[1])
            result[2] = tf.add(result[2], prediction[2])
        }
    }
    return [result[0].div(tf.scalar(predictions.length)).dataSync(), result[1].div(tf.scalar(predictions.length)).dataSync(), result[2].div(tf.scalar(predictions.length)).dataSync()]
}